import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getFloors = async (facilityId) => {
  return await request.get(
    `RentPlace/rental_house/${facilityId}/floor`,
    {},
    'При загрузке этажей объекта произошла ошибка',
    []
  );
};

const useFloors = (facilityId) =>
  useQuery(
    [queries.facilityFloors, facilityId],
    () => getFloors(facilityId),
    {
      placeholderData: [],
      enabled: !!facilityId,
    }
  );

export default useFloors;
